<header class="header">
  <div class="header-container">

    <a href="/" class="logo">
      <img src="/LogoColorida.svg" alt="CuidaZap">
    </a>

    <nav class="nav-menu">
      <a href="/">Home</a>
      <a href="https://cuidazap.com/quem-somos">Quem Somos</a>
      <a href="#como-funciona">Como Funciona</a>
      <a href="https://painel.cuidazap.com/checkout">Planos</a>
      <a href="https://wa.me/5511965721445?text=Quero+saber+mais+sobre+o+CuidaZap&utm_source=chatgpt.com">Contatos</a>
    </nav>

    <a href="https://painel.cuidazap.com/checkout" class="btn-assinar">
      ASSINAR AGORA
    </a>

    <button
      class="menu-toggle"
      [class.active]="menuAberto"
      (click)="toggleMenu()"
      aria-label="Abrir menu"
    >
      <span></span>
      <span></span>
      <span></span>
    </button>

  </div>
</header>

<div
  class="menu-overlay"
  [class.active]="menuAberto"
  (click)="fecharMenu()"
></div>

<aside
  class="side-menu"
  [class.active]="menuAberto"
>

  <div class="side-menu-header">

    <button
      class="close-menu"
      (click)="fecharMenu()"
      aria-label="Fechar menu"
    >
      ×
    </button>

  </div>

  <nav class="side-nav">

    <a href="/" (click)="fecharMenu()">
      Home
    </a>

    <a href="#quem-somos" (click)="fecharMenu()">
      Quem Somos
    </a>

    <a href="#como-funciona" (click)="fecharMenu()">
      Como Funciona
    </a>

    <a href="https://painel.cuidazap.com/checkout" (click)="fecharMenu()">
      Planos
    </a>

    <a href="https://wa.me/5511976240075?text=Quero+saber+mais+sobre+o+CuidaZap&utm_source=chatgpt.com" (click)="fecharMenu()">
      Contatos
    </a>

  </nav>

  <a
    href="https://painel.cuidazap.com/checkout"
    class="side-btn-assinar"
    (click)="fecharMenu()"
  >
    ASSINAR AGORA
  </a>

</aside>
